import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import { handleRateLimit } from "utils/handleRateLimit";
import { getClientIp } from "utils/requestHelpers";
import { parseVisibleCount, sliceTestimonials, TESTIMONIALS_STEP } from "utils/paginateTestimonials";
import PageHead from "@components/Components/Reusables/PageHead";
import Head from "next/head";
import Testimonials from "../js/Components/Testimonials/Testimonials";

const testimonials = ({ data }) => {
    const meta = data.template_page_content.meta;

    return (
        <>
            <PageHead
                title={meta.meta_title}
                description={meta.meta_description}
                ogTitle={meta.og_title}
                ogDescription={meta.og_description}
                ogType={meta.og_type}
                ogUrl={meta.og_url}
                ogImage={meta.og_image}
            />
            {data.loadMore.visible > TESTIMONIALS_STEP && (
                <Head>
                    <meta name="robots" content="noindex, follow" />
                </Head>
            )}
            <PageContextWrapper
                page='testimonial'
                page_content={data.template_page_content}
            >
                <Testimonials {...data} />
            </PageContextWrapper>
        </>
    );
};

export async function getServerSideProps({ req, res, query }) {
    const visible = parseVisibleCount(query.show);
    if (visible === null) return { notFound: true };

    const { headers } = getClientIp(req);

    try {
        const apiReq = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}testimonials`, { headers });

        let data = null;

        try {
            data = await apiReq.json();
        } catch (error) {
            console.error('Invalid API response:', error);
        }

        const rateLimitRedirect = handleRateLimit(res, apiReq, data);
        if (rateLimitRedirect) return rateLimitRedirect;

        if (!data || data?.exception || !Array.isArray(data.testimonials)) {
            return { notFound: true }
        }

        const sliced = sliceTestimonials(data.testimonials, visible);
        if (!sliced) return { notFound: true };

        res.setHeader(
            'Cache-Control',
            'public, s-maxage=43200, stale-while-revalidate=59'
        );

        return {
            props: {
                data: {
                    ...data,
                    testimonials: sliced.items,
                    loadMore: {
                        visible: sliced.visible,
                        nextVisible: sliced.nextVisible,
                    },
                },
            },
        };

    } catch (error) {
        return { notFound: true } //404
    }
}

export default testimonials;
